module.exports = __webpack_public_path__ + "img/giffey-ruecktritt.7c2f66d9.png";